import { render, staticRenderFns } from "./PreguntasHc.vue?vue&type=template&id=2b8b5a07&scoped=true"
import script from "./PreguntasHc.vue?vue&type=script&lang=js"
export * from "./PreguntasHc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b5a07",
  null
  
)

export default component.exports